const EXTERNAL_ID_SESSION_STORAGE_KEY = 'external_id';

// adhoc enum of stratum customer attribute id
const NewRelicCustomAttribute = Object.freeze({
  PRODUCT_TYPE: 'productType',
  EXTERNAL_ID: 'externalId',
  IS_WEBVIEW: 'isWebView',
  CHANNEL: 'channel',
});

function isWebView(userAgent) {
  return userAgent?.includes('c1native') ? 'web view' : null;
}

function parseChannelFromExternalId(extId) {
  if (!extId?.match(/^(external_id\^)?COAF_V1_[A-Z]{2,4}_?/)) return null;
  const externalIdIndex = extId.indexOf('V1_') + 3;
  const thirdUnderscore = extId.indexOf('_', externalIdIndex);
  return extId.slice(externalIdIndex, thirdUnderscore > 0 ? thirdUnderscore : undefined);
}

export { EXTERNAL_ID_SESSION_STORAGE_KEY, NewRelicCustomAttribute, isWebView, parseChannelFromExternalId };
